var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('strong',[_vm._v("Fecha de Accidente: ")]),_vm._v("\n    "+_vm._s(_vm._f("shortDate")(_vm.dateOccurred))+"\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Fecha de Asignación: ")]),_vm._v("\n    "+_vm._s(_vm._f("shortDate")(_vm.dateAssignment))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/RoadSinisters/SinisterDates.vue